import React from 'react';

const Background = () => (
  <div
    className="fixed-top vh-100 vw-100 overflow-hidden"
    style={{ zIndex: -1 }}
  >
    <div
      className="img-bg"
      style={{
        backgroundImage: 'url("/assets/img/bg-bg.jpg")',
        backgroundPosition: '100% 15%',
      }}
    />
    <div
      className="position-absolute anim-cloud slow"
      src="/assets/img/bg-cloud.png"
      alt=""
      style={{
        width: '16%',
        right: '-2%',
        top: '50%',
        minWidth: '120px',
      }}
    >
      <img
        className="w-100"
        src="/assets/img/bg-cloud.png"
        alt=""
        style={{
          transform: 'scaleX(-1)',
        }}
      />
    </div>
    <img
      className="position-absolute anim-cloud"
      src="/assets/img/bg-cloud.png"
      alt=""
      style={{
        width: '20%',
        left: '30%',
        bottom: '17%',
        minWidth: '200px',
      }}
    />
    <img
      className="w-100 position-absolute"
      src="/assets/img/bg-fg.png"
      alt=""
      style={{
        minWidth: '1000px',
        right: 'auto',
        bottom: '-40px',
      }}
    />
    <img
      className="position-absolute bottom-0 anim-fg-cloud"
      src="/assets/img/bg-fg-cloud.png"
      alt=""
      style={{
        width: '75%',
        minWidth: '600px',
        left: '30%',
      }}
    />
    <div
      className="position-absolute w-100 text-end"
      style={{
        bottom: '9vw',
        minWidth: '1000px',
      }}
    >
      <img
        src="/assets/img/bg-house.png"
        style={{
          width: '15%',
          marginRight: '15%',
        }}
        alt=""
      />
    </div>
    <div
      className="position-absolute w-100 text-end"
      style={{
        bottom: '4vw',
        minWidth: '550px',
      }}
    >
      <img
        src="/assets/img/bg-medicine.png"
        style={{
          width: '13%',
          marginRight: '32%',
          minWidth: '150px',
        }}
        alt=""
      />
    </div>
    <div
      className="position-absolute w-100 text-end"
      style={{
        minWidth: '1500px',
        bottom: '0vh',
      }}
    >
      <img
        src="/assets/img/bg-stone.png"
        style={{
          width: '100%',
        }}
        alt=""
      />
    </div>
  </div>
);

export default Background;
